import { FOOTNOTE_IDS } from '@oneaudi/confi-shared-components';
import { FootnoteReferenceV2 } from '@oneaudi/feature-app-utils';
import { Footnote } from '@oneaudi/footnote-service/dist/cjs/types/footnotes-response.type';
import { useAppServices } from '~/app/contexts/app-context';
import { useI18n } from '~/app/i18n/i18n';

export default function MonthlyRateFootnote({ text }: { text: unknown }) {
	const {
		featureServices: { footnoteService },
	} = useAppServices();
	const { i18n } = useI18n();

	if (text) {
		const footnoteKey = `price-${FOOTNOTE_IDS.financingCalculationDisclaimer}`;
		const footnote = [{ Key: footnoteKey, Text: text?.toString() ?? '' } as Footnote];
		const alreadyExistingFootnotes = footnoteService?.getData();

		const footnoteFound = alreadyExistingFootnotes?.find((d) => d.Key === footnoteKey);
		if (footnoteFound) {
			footnoteService?.replaceFootNotes(footnote);
		} else {
			footnoteService?.addFootNotes(footnote);
		}
	}

	return (
		<FootnoteReferenceV2
			footnoteId={`price-${FOOTNOTE_IDS.financingCalculationDisclaimer}`}
			footnoteAriaLabel={i18n('ngc.a11y.footnotes.financing')}
		/>
	);
}
